export default __webpack_public_path__ + "static/media/result_body_obese.ea229fd8.jpg";